<template>
  <div
    class="bb-notifications-bar-popup-menu"
    @mouseleave="showPopup = false"
  >
    <div
      class="bb-notifications-bar-popup-menu__item"
      @click="onReadAll"
    >
      Mark all as read
    </div>
    <div
      class="bb-notifications-bar-popup-menu__item"
      @click="onDeleteAll"
    >
      Delete all notifications
    </div>
  </div>
</template>

<script>

import TimeoffNotificationApi from '@/api/NotificationTimeoff/api'
import { HR_NOTIFICATION_RAED_STATUS_ID } from '@/constants/hrNotificationReadStatus'

export default {
  name: 'NotificationsBarPopupMenu',
  props: {
    isShowPopup: {
      type: Boolean,
      default: false
    },
    notificationsList: {
      type: Array,
      default: () => ([])
    },
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    showPopup: {
      get () {
        return this.isShowPopup
      },
      set (data) {
        this.$emit('update:isShowPopup', data)
      }
    },
    notifications: {
      get () {
        return this.notificationsList
      },
      set (data) {
        this.$emit('update:notificationsList', data)
      }
    }
  },
  methods: {
    async onReadAll () {
      const { id } = this.userInfo
      this.notifications.forEach((el) => {
        el.readStatus = HR_NOTIFICATION_RAED_STATUS_ID
      })
      try {
        await TimeoffNotificationApi.readHrNotificationAll(id)
      } catch (err) {
        console.error(err)
      }
    },
    async onDeleteAll () {
      const { id } = this.userInfo
      this.notifications = []
      try {
        await TimeoffNotificationApi.deleteHrNotificationAll(id)
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bb-notifications-bar-popup-menu {
    position: absolute;
    top: 48px;
    right: 16px;
    width: 160px;
    height: 72px;
    padding: 5px 0 5px 0;
    border-radius: 5px;
    background: $color-white;
    box-shadow: 0 0 20px rgba($color-black, 0.06);
    z-index: 1;

    &__item {
      padding: 7px 12px;
      font-size: 14px;
      font-weight: 300;
      line-height: 17px;
      transition: 0.3s;

      &:hover {
        background: $color-wild-sand;
        cursor: pointer;
      }
    }

    &:after {
      content: '';
      position: absolute;
      right: 7px;
      top: -5px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid $color-white;
      box-shadow: 0 0 20px rgba($color-black, 0.06);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsBar/NotificationsBarPopupMenu.vue